import { call, take, takeLatest, put } from 'redux-saga/effects';

import { getStorage, setStorage, storageKeys } from 'app/utils/localStorage';

import {
  Actions as QuestionsGetAllActions,
  Types as QuestionsGetAllTypes,
} from 'app/redux/questions/get-all/actions';
import { Actions as QuestionsCategoryOptionsActions } from 'app/redux/questions/category-options/actions';
import { Actions, Types } from './actions';

const fetchQuestionData = function*() {
  yield put(QuestionsGetAllActions.request());

  const getQuestionsSuccess = yield take(QuestionsGetAllTypes.SUCCESS);

  if (getQuestionsSuccess) {
    yield call(
      setStorage,
      storageKeys.QUESTIONS_GET_ALL_RESULT,
      getQuestionsSuccess.result
    );
  }
};

const initialize = function*() {
  const cachedQuestions = yield call(
    getStorage,
    storageKeys.QUESTIONS_GET_ALL_RESULT
  );
  const cachedAnswers = yield call(getStorage, storageKeys.SELECTED_ANSWERS);

  if (cachedQuestions) {
    yield put(QuestionsGetAllActions.success(cachedQuestions));
  }
  if (cachedAnswers) {
    yield put(Actions.selectAnswer(cachedAnswers));
  }

  if (!cachedQuestions) {
    yield call(fetchQuestionData);
  }

  yield put(QuestionsCategoryOptionsActions.request());
};

const QuestionsSaga = function*() {
  yield takeLatest(Types.INITIALIZE, initialize);
};

export default QuestionsSaga;



// WEBPACK FOOTER //
// ./src/redux/ui/questions/sagas.js